import { useState, useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import LockIcon from "@mui/icons-material/Lock";
import MainContext from "../../context/mainContext";
import GetFreeTrialDict from "./GetFreeTrialDict";

function AccessDeny(props) {
  const { onlyUserPremium, trailDict, handleFullScreen, handlePlayingStatus } =
    props;
  const [openGetFreeTrialDict, setOpenGetFreeTrialDict] = useState(false);
  const { handleOpenSignInBox, handlePageNumber, userTypes, videoInfo } =
    useContext(MainContext);

  const handleGetFreeTrialDict = (state) => {
    setOpenGetFreeTrialDict(state);
  };
  return (
    <Card>
      <GetFreeTrialDict
        handleFullScreen={handleFullScreen}
        trailDict={trailDict}
        openGetFreeTrialDict={openGetFreeTrialDict}
        handleGetFreeTrialDict={handleGetFreeTrialDict}
      />
      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[200]
              : theme.palette.grey[700],
          mx: "auto",
          px: "auto",
        }}
      >
        <Box sx={{ textAlign: "center", color: "#ed4f4f", height: 35 }}>
          <LockIcon
            sx={{ textAlign: "center", height: "100%", width: "100%" }}
          />
        </Box>{" "}
      </Box>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
          }}
        >
          <Box
            // component="h5"
            // variant="h5"
            color="text.primary"
            sx={{ textAlign: "center" }}
          >
            {onlyUserPremium ? (
              <>
                <Typography
                  sx={{ border: "1px #893d0d dashed", borderRadius: "10px" }}
                >
                  سرویس ترجمه لغت
                </Typography>
                <Typography>مخصوص کاربران ویژه</Typography>
              </>
            ) : (
              <>
                <Typography
                  sx={{ border: "1px #893d0d dashed", borderRadius: "10px" }}
                >
                  سرویس ترجمه لغت
                </Typography>
                <Typography>لطفا وارد برنامه شوید</Typography>
              </>
            )}
          </Box>
        </Box>
      </CardContent>
      <CardActions>
        {onlyUserPremium ? (
          <Box sx={{ textAlign: "center" }}>
            <Button
              onClick={() => {
                handlePageNumber("", 2);
                handleFullScreen.exit();
              }}
              variant="contained"
              className="yn-showPackages1 yn-showPackages"
              fullWidth
              color="info"
              sx={{ width: "90%" }}
            >
              دریافت اشتراک ویژه
              <br />
              (امکان دریافت رایگان)
            </Button>
            <Button
              onClick={() => {
                handleGetFreeTrialDict(true);
                handleFullScreen.exit();
              }}
              className="yn-freeTrial1 yn-freeTrial"
              variant="contained"
              fullWidth
              color="warning"
              size="small"
              sx={{ fontSize: 10, width: "60%", mt: 0.5 }}
            >
              استفاده آزمایشی رایگان
            </Button>
          </Box>
        ) : (
          <Button
            onClick={() => {
              handleOpenSignInBox();
              handlePlayingStatus(false);
            }}
            variant="contained"
            fullWidth
            color="info"
            sx={{ fontSize: 10 }}
          >
            ورود / ثبت نام
          </Button>
        )}
      </CardActions>
    </Card>
  );
}

export default AccessDeny;
